import React from 'react';
import { useQuery, useMutation } from '@apollo/client';

function withQuery(query, params) {
    let name = params?.name ? params?.name : null, options = params?.options ? params?.options : null;
    return (WrappedComponent) => {
        return (props) => {
            let requestData = (typeof options == 'function') ? options(props) : options;
            const { data, ...rest } = useQuery(query, requestData);
            props = { ...props, ...{ [name ? name : 'data']: { ...data, ...rest } } };
            return (
                <WrappedComponent {...props} />
            );
        };
    }
}

function withMutation(mutation, params) {
    return (WrappedComponent) => {
        return (props) => {
            const [mutate] = useMutation(mutation);
            props = params?.name ? { ...props, [params['name']]: mutate } : { ...props, mutate };
            return (
                <WrappedComponent {...props} />
            );
        };
    }
}

export { withQuery, withMutation };